let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aEZEj")).then(() => parcelRequire('eYFK8'));